import withIsVisibleHOC, { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import classnames from "classnames";
import * as React from "react";
import { getWidgetDataAttributes } from "../lib";
import SidePanelToggle from "../SidePanel/Toggle/container";
import Background from "./Background/container";
import Cart from "./Cart/container";
import HeaderElement from "./Element/container";
import { Tracker } from "./lib";
import Login from "./Login/container";
import Logo from "./Logo/container";
import Menu from "./MainMenu/container";
import MenuToggle from "./MainMenu/Toggle/container";
import SearchBar from "./Search/container";
import SearchToggle from "./Search/Toggle/container";

import "./style.less";

export const INVISIBLE_PROPS: MapProps & WithIsVisibleHOCProps = {
  className: "",
  containerStyle: {},
  contentStyle: {},
  isMenuOpen: false,
  isSticky: false,
  isStickyActive: false,
  isVisible: false,
  style: {}
};

export type MapProps = {
  className: string;
  containerStyle: React.CSSProperties;
  contentStyle: React.CSSProperties;
  isMenuOpen: boolean;
  isSticky: boolean;
  isStickyActive: boolean;
  style: React.CSSProperties;
};

export interface ActionProps {
  onDoubleClick?: () => void;
  setSticky: (isSticky: boolean) => void;
}

const Header = ({ isSticky, isStickyActive, setSticky, containerStyle, ...props }: ActionProps & MapProps) => {
  const tracker = new Tracker();

  React.useEffect(() => {
    tracker.update(isSticky, setSticky);
    return () => tracker.destroy();
  }, [isSticky, setSticky]);

  return (
    // don't use overflow hidden on the parents tags, it breaks header sticky mode
    <div
      id="header_wrap"
      className={classnames({ sticky: isSticky && isStickyActive })}
      style={containerStyle}
      onDoubleClick={props.onDoubleClick}
    >
      <header
        id="header"
        className={classnames(props.className)}
        style={props.style}
        {...getWidgetDataAttributes("header", "Header")}
      >
        <Background />

        <div className="wsc_header_content" style={props.contentStyle}>
          <MenuToggle isLeft />
          <Logo />

          <div className="wsc_header_content_inner">
            <SearchBar />
            <Menu isDesktop />
            <MenuToggle isLeft={false} />
            <SearchToggle />
            <Login />
            <Cart />
            <HeaderElement>
              <SidePanelToggle isOutsideHeader={false} />
            </HeaderElement>
          </div>
        </div>

        <Menu isDesktop={false} />
      </header>
    </div>
  );
};
export default withIsVisibleHOC(Header);
